var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAudioPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19218",
    "data-name": "Rectangle 19218",
    width: 22.02,
    height: 17.153,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "off",
    transform: "translate(21832 19309)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10508",
    "data-name": "Ellipse 10508",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(-21832 -19309)",
    opacity: 0.197
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69635",
    "data-name": "Group 69635",
    transform: "translate(-21825.01 -19299.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69634",
    "data-name": "Group 69634",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155635",
    "data-name": "Path 155635",
    d: "M11,16.67a1,1,0,0,1-.654-.244L5.417,12.162H1a1,1,0,0,1-1-1V5.444a1,1,0,0,1,1-1H5.49l4.856-4.2A1,1,0,0,1,12,1V15.67a1,1,0,0,1-1,1",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155636",
    "data-name": "Path 155636",
    d: "M18.331,17.153a1,1,0,0,1-.779-1.626,11.032,11.032,0,0,0,0-13.9A1,1,0,1,1,19.111.375a13.019,13.019,0,0,1,0,16.4,1,1,0,0,1-.78.374m-3.638-2a1,1,0,0,1-.8-1.593,8.313,8.313,0,0,0,0-9.914A1,1,0,1,1,15.5,2.461a10.3,10.3,0,0,1,0,12.286,1,1,0,0,1-.806.407",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudioPlay);
export default __webpack_public_path__ + "static/media/icon-audio-play.9a295dd65d33f368ca793aa9d62873ca.svg";
export { ForwardRef as ReactComponent };